export default  {
  get (storeId) {
    try {
      if (process.env.NODE_ENV === 'test') {
        return new Error('dom nodes are not avaible in test mode');
      }

      const storeSelector = '[data-store=' + storeId + ']';
      const store = document.querySelector(storeSelector);

      if (!store) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Error Loading Store', storeId);
        }
        return new Error(storeId + ' This store does not exist on the page');
      }
      return JSON.parse(store.textContent || store.innerHTML);
    }
    catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Error Loading Store', storeId, e.stack);
      }
      return e;
    }
  }
};



// WEBPACK FOOTER //
// ./frontend/react/utils/store/index.js